import { IRoutesDefined } from "@/api_framework/api_modals/Routers";
import { TRANSFER_SUB_NAV_ROUTES } from "./order";

export const PURCHASE_ADD_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  PRIMARY_PRODUCT_INFORMATION_READ_ONLY: {
    id: "PRIMARY_PRODUCT_INFORMATION_READ_ONLY",
    title: "PURCHASE_ADD",
    path: "purchase-add",
    RBACDescription: "Read only permission to primary product information on create PO",
    url: "/app/inventory/purchase-add-ppi-r",
    description: "Add purchase",
    isVirtual: true,
    children: {},
  },
  PRIMARY_PRODUCT_INFORMATION_EDIT: {
    id: "PRIMARY_PRODUCT_INFORMATION_EDIT",
    title: "PURCHASE_ADD",
    path: "purchase-add",
    RBACDescription: "Edit only permission to primary product information on create PO",
    url: "/app/inventory/purchase-add-ppi-e",
    description: "Add purchase",
    isVirtual: true,
    children: {},
  },
  MANAGE_INVOICE_READ_ONLY: {
    id: "MANAGE_INVOICE_READ_ONLY",
    title: "Manage invoices",
    path: "purchase-add",
    RBACDescription: "Read only permission to manage invoices",
    url: "/app/inventory/purchase-add-invoice-r",
    description: "manage invoices",
    isVirtual: true,
    children: {},
  },
  MANAGE_INVOICE_EDIT: {
    id: "MANAGE_INVOICE_EDIT",
    title: "Manage invoices",
    path: "purchase-add",
    RBACDescription: "Write only permission to manage invoices",
    url: "/app/inventory/purchase-add-invoice-e",
    description: "manage invoices",
    isVirtual: true,
    children: {},
  },
  PRODUCT_INFORMATION_READ_ONLY: {
    id: "PRODUCT_INFORMATION_READ_ONLY",
    title: "Manage product information",
    path: "purchase-add",
    RBACDescription: "Read only permission to manage product information",
    url: "/app/inventory/purchase-add-pi-r",
    description: "manage product information",
    isVirtual: true,
    children: {},
  },
  PRODUCT_INFORMATION_EDIT: {
    id: "PRODUCT_INFORMATION_EDIT",
    title: "Manage product information",
    path: "purchase-add",
    RBACDescription: "Write only permission to manage product information",
    url: "/app/inventory/purchase-add-pi-e",
    description: "manage product information",
    isVirtual: true,
    children: {},
  },
  PO_MANAGE_INVOICE: {
    id: "PO_MANAGE_INVOICE",
    title: "Manage invoice section",
    path: "purchase-add",
    RBACDescription: "Manage invoice section in PO create page.",
    url: "/app/inventory/purchase-add-manage-invoice",
    description: "manage product information",
    isVirtual: true,
    children: {},
  },
};

export const INVENTORY_SUB_NAVIGATION_ROUTES: IRoutesDefined = {
  HSN_AND_TAX_SETUP: {
    id: "HSN_AND_TAX_SETUP",
    title: "Hsn & Tax",
    icon: "HiOutlineHome",
    url: "/app/inventory/hsn-tax",
    path: "hsn-tax",
    children: {},
  },
  TAX_ADD: {
    id: "TAX_ADD",
    title: "TAX ADD",
    icon: "HiOutlineHome",
    url: "/app/inventory/tax-add",
    path: "tax-add",
    children: {},
  },
  BATCH_SETUP: {
    id: "BATCH_SETUP",
    title: "BATCH_SETUP",
    icon: "HiOutlineHome",
    url: "/app/inventory/batch",
    path: "batch",
    children: {},
  },
  BATCH_ADD: {
    id: "BATCH_ADD",
    title: "BATCH_ADD",
    icon: "HiOutlineHome",
    url: "/app/inventory/batch-add",
    path: "batch-add",
    children: {},
  },
  MANUFACTURER_SETUP: {
    id: "MANUFACTURER_SETUP",
    title: "MANUFACTURER_SETUP",
    icon: "HiOutlineHome",
    url: "/app/inventory/manufacture",
    path: "manufacture",
    children: {},
  },
  MANUFACTURER_ADD: {
    id: "MANUFACTURER_ADD",
    title: "MANUFACTURER_ADD",
    icon: "HiOutlineHome",
    url: "/app/inventory/manufacture-add",
    path: "manufacture-add",
    children: {},
  },
  // Vendors
  VENDORS_LIST: {
    id: "VENDORS_LIST",
    title: "VENDORS_LIST",
    path: "vendors-list",
    url: "/app/inventory/vendors-list",
    description: "Vendors list for inventory",
    children: {},
  },
  //PRODUCT
  PRODUCT_LIST: {
    id: "PRODUCT_LIST",
    title: "PRODUCT_LIST",
    path: "product-list",
    url: "/app/inventory/product-list",
    description: "Vendors list for inventory",
    children: {},
  },
  PRODUCT_ADD: {
    id: "PRODUCT_ADD",
    title: "PRODUCT_ADD",
    path: "product-add",
    url: "/app/inventory/product-add",
    description: "Vendors list for inventory",
    children: {},
  },
  PRODUCT_PERSONA_DISCOUNT: {
    id: "PRODUCT_PERSONA_DISCOUNT",
    title: "Product Persona Discount",
    path: "product-persona-discount",
    url: "/app/inventory/product-persona-discount",
    description: "Persona-based listing discounts for a product's variants",
    RBACDisplayName: "Product Persona Discount",
    RBACDescription: "Access to author persona-based listing discounts for product variants.",
    isVirtual: true,
    children: {},
  },
  VETIC_EMBED: {
    id: "VETIC_EMBED",
    title: "vetic embed",
    path: "cta",
    url: "/app/inventory/vetic-embed-cta",
    RBACDisplayName: "VETIC_EMBED",
    RBACDescription: "Access to the Vetic embed feature within inventory.",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PRODUCT_SETUP: {
    id: "PRODUCT_SETUP",
    title: "Product Setup",
    path: "product-setup",
    url: "/app/inventory/product-setup",
    RBACDisplayName: "Product Setup",
    RBACDescription: "Access to product general details setup section.",
    isVirtual: true,
    children: {},
  },
  CATALOGUE_SETUP: {
    id: "CATALOGUE_SETUP",
    title: "Catalogue Setup",
    path: "catalogue-setup",
    url: "/app/inventory/catalogue-setup",
    RBACDisplayName: "Catalogue Setup",
    RBACDescription: "Access to product catalogue details setup section.",
    isVirtual: true,
    children: {},
  },
  VENDOR_ADD: {
    id: "VENDOR_ADD",
    title: "VENDOR_ADD",
    path: "vendor-add",
    url: "/app/inventory/vendor-add",
    description: "Add vendors",
    children: {},
  },
  //Service Onboard
  SERVICE_LIST: {
    id: "SERVICE_LIST",
    title: "SERVICE_LIST",
    path: "service-list",
    url: "/app/inventory/service-list",
    description: "Service List",
    children: {},
  },
  SERVICE_ADD: {
    id: "SERVICE_ADD",
    title: "SERVICE_ADD",
    path: "service-add",
    url: "/app/inventory/service-add",
    description: "Add Service",
    children: {},
  },
  //PO creation
  PURCHASE_LIST: {
    id: "PURCHASE_LIST",
    title: "purchase order",
    path: "purchase-list",
    url: "/app/inventory/purchase-list",
    description: "purchase List",
    children: {},
  },
  PURCHASE_ADD: {
    id: "PURCHASE_ADD",
    title: "PURCHASE_ADD",
    path: "purchase-add",
    url: "/app/inventory/purchase-add",
    description: "Add purchase",
    children: {
      ...PURCHASE_ADD_SUB_NAVIGATION_ROUTES,
    },
  },
  PENDING_GOODS: {
    id: "PENDING_GOODS",
    title: "PENDING_GOODS",
    path: "pending-goods",
    url: "/app/inventory/pending-goods",
    description: "pending goods",
    children: {},
  },
  GRN_DONE: {
    id: "GRN_DONE",
    title: "Grn Done",
    path: "goods-done",
    url: "/app/inventory/goods-done",
    description: "goods done",
    children: {},
  },

  INVENTORY_SNAPSHOT: {
    id: "INVENTORY_SNAPSHOT",
    title: "Inventory Snapshot",
    path: "inventory-snapshot",
    url: "/app/inventory/inventory-snapshot",
    description: "inventory snapshot",
    children: {},
  },
  DOCTOR_INVENTORY: {
    id: "DOCTOR_INVENTORY",
    title: "Doctor Inventory",
    path: "doctor-inventory",
    url: "/app/inventory/doctor-inventory",
    description: "view inventory assigned to doctors",
    rbacActionId: "AHS_Inventory_Transfer",
    isVirtual: false,
    RBACDisplayName: "DOCTOR_INVENTORY",
    RBACDescription: "Access to view inventory assigned to doctors",
    children: {},
  },
  INVENTORY_SNAPSHOT_EXPORT_AS_CSV: {
    id: "INVENTORY_SNAPSHOT_EXPORT_AS_CSV",
    title: "Inventory Snapshot export button",
    path: "inventory-snapshot-csv",
    url: "/app/inventory/inventory-snapshot-csv",
    description: "inventory snapshot csv button",
    RBACDescription: "inventory snapshot csv button",
    isVirtual: true,
    children: {},
  },
  ACTIONS_ON_GOOD_INVENTORY: {
    id: "ACTIONS_ON_GOOD_INVENTORY",
    title: "Actions On Good Inventory",
    path: "good-inventory",
    url: "/app/inventory/good-inventory",
    description: "good inventory",
    children: {},
  },
  BAD_INVENTORY_REQUESTS: {
    id: "BAD_INVENTORY_REQUESTS",
    title: "bad inventory requests",
    path: "bad-inventory",
    url: "/app/inventory/bad-inventory",
    description: "bad inventory",
    children: {},
  },
  TRANSFER_GOOD_INVENTORY: {
    id: "TRANSFER_GOOD_INVENTORY",
    title: "transfer good inventory",
    path: "transfer-good-inventory",
    url: "/app/inventory/transfer-good-inventory",
    description: "transfer good inventory",
    children: {},
  },
  TRANSFER_BAD_INVENTORY: {
    id: "TRANSFER_BAD_INVENTORY",
    title: "Transfer bad inventory",
    path: "transfer-bad-inventory",
    url: "/app/inventory/transfer-bad-inventory",
    description: "transfer bad inventory",
    children: {},
  },
  TRANSFER_ORDER_READ_ONLY: {
    id: "TRANSFER_ORDER_READ_ONLY",
    title: "TRANSFER_ORDER_READ_ONLY",
    path: "transfer-orders-list",
    url: "/app/inventory/transfer-orders-list",
    description: "transfer orders list",
    children: {},
  },
  TRANSFER_ORDER_DETAILS: {
    id: "TRANSFER_ORDER_DETAILS",
    title: "TRANSFER_ORDER_DETAILS",
    path: "transfer-order-details",
    url: "/app/inventory/transfer-order-details",
    description: "transfer order details",
    children: {},
  },
  BOM_SETUP: {
    id: "BOM_SETUP",
    title: "bom setup",
    description: "bom setup",
    url: "/app/inventory/bom-setup",
    path: "bom-setup",
    children: {},
  },
  BOM_ONBOARD: {
    id: "BOM_ONBOARD",
    title: "bom onboard",
    description: "bom onboard",
    url: "/app/inventory/bom-onboard",
    path: "bom-onboard",
    children: {},
  },
  BOM_GENERAL_DETAILS: {
    id: "BOM_GENERAL_DETAILS",
    title: "BOM general details",
    icon: "HiOutlineHome",
    url: "/app/inventory/bom-onboard-general",
    RBACDescription: "BOM_GENERAL_DETAILS",
    description: "Finacne PO",
    isVirtual: false,
    path: "bom-onboard-general",
    children: {},
  },
  BOM_TAX_DETAILS: {
    id: "BOM_TAX_DETAILS",
    title: "BOM general details",
    icon: "HiOutlineHome",
    url: "/app/inventory/bom-onboard-tax",
    RBACDescription: "BOM_TAX_DETAILS",
    description: "Finacne PO",
    isVirtual: false,
    path: "bom-onboard-tax",
    children: {},
  },
  // BOM_SETUP_ONBOARD_EDIT: {
  //   id: "BOM_SETUP_ONBOARD_EDIT",
  //   title: "bom_setup_onboard_edit",
  //   icon: "",
  //   RBACDescription: "Access to  onboard bom  page  and action.",
  //   url: "/app/inventory/bom-onboard",
  //   path: "bom-onboard",
  //   children: {},
  // },
  ITEM_GROUP_SETUP: {
    id: "ITEM_GROUP_SETUP",
    title: "item group setup",
    description: "item group setup",
    url: "/app/inventory/item-group-setup",
    path: "item-group-setup",
    children: {},
  },
  ITEM_GROUP_ONBOARD: {
    id: "ITEM_GROUP_ONBOARD",
    title: "item group onboard",
    description: "item group onboard",
    url: "/app/inventory/item-group-onboard",
    path: "item-group-onboard",
    children: {},
  },
  SURGE_PRICING_LIST: {
    id: "SURGE_PRICING_LIST",
    title: "surge pricing",
    description: "surge pricing rules",
    url: "/app/inventory/surge-pricing",
    path: "surge-pricing",
    RBACDisplayName: "Surge Pricing",
    RBACDescription: "View surge (uplift) pricing rules. Editing is limited to the central pricing roles.",
    children: {},
  },
  SURGE_PRICING_ONBOARD: {
    id: "SURGE_PRICING_ONBOARD",
    title: "surge pricing rule",
    description: "create or edit a surge pricing rule",
    url: "/app/inventory/surge-pricing-rule",
    path: "surge-pricing-rule",
    children: {},
  },
  SURGE_PRICING_PRICE_CHECK: {
    id: "SURGE_PRICING_PRICE_CHECK",
    title: "surge price check",
    description: "check the surge price of an item",
    url: "/app/inventory/surge-price-check",
    path: "surge-price-check",
    children: {},
  },
  CATEGORY_SETUP: {
    id: "CATEGORY_SETUP",
    title: "category setup",
    description: "category setup",
    url: "/app/inventory/category-setup",
    path: "category-setup",
    children: {},
  },
  CATEGORY_ONBOARD: {
    id: "CATEGORY_ONBOARD",
    title: "category onboard",
    description: "category onboard",
    url: "/app/inventory/category-onboard",
    path: "category-onboard",
    children: {},
  },
  SUB_CATEGORY_SETUP: {
    id: "SUB_CATEGORY_SETUP",
    title: "sub category setup",
    description: "sub category setup",
    url: "/app/inventory/sub-category-setup",
    path: "sub-category-setup",
    children: {},
  },
  SUB_CATEGORY_ONBOARD: {
    id: "SUB_CATEGORY_ONBOARD",
    title: "sub-category onboard",
    description: "sub-category onboard",
    url: "/app/inventory/sub-category-onboard",
    path: "sub-category-onboard",
    children: {},
  },
  CATEGORY_MAPPING: {
    id: "CATEGORY_MAPPING",
    title: "category mapping",
    description: "category mapping",
    url: "/app/inventory/category-mapping",
    path: "category-mapping",
    children: {},
  },
  CATEGORY_MAPPING_ONBOARD: {
    id: "CATEGORY_MAPPING_ONBOARD",
    title: "category mapping onboard",
    description: "category mapping onboard",
    url: "/app/inventory/category-mapping-onboard",
    path: "category-mapping-onboard",
    children: {},
  },
  ADD_INVENTORY: {
    id: "ADD_INVENTORY",
    title: "Add Inventory",
    path: "add-inventory",
    url: "/app/inventory/add-inventory",
    description: "add inventory",
    isVirtual: false,
    children: {},
  },
  MRP_UPDATE: {
    id: "MRP_UPDATE",
    title: "Mrp Update",
    path: "mrp-update",
    url: "/app/inventory/mrp-update",
    description: "mrp update",
    isVirtual: false,
    children: {},
  },
  PO_DELETE_ACTION_CTA: {
    id: "PO_DELETE_ACTION_CTA",
    title: "po delete",
    RBACDescription: "Access to po delete",
    RBACDisplayName: "INVENTORY_PO_DELETE_ACTION_CTA",
    icon: "BsCardChecklist",
    path: "cta-action-po-delete",
    url: "/app/inventory/purchase-list/cta-del",
    isVirtual: true,
    children: {},
  },
  RECEIVE_GOODS_ACTION_CTA: {
    id: "RECEIVE_GOODS_ACTION_CTA",
    title: "receive goods",
    RBACDescription: "Access to receive goods",
    RBACDisplayName: "INVENTORY_RECEIVE_GOODS_ACTION_CTA",
    icon: "BsCardChecklist",
    path: "cta-action-receive-goods",
    url: "app/inventory/purchase-add/cta-receive-goods",
    isVirtual: true,
    children: {},
  },
  AUDIT_TRAIL: {
    id: "AUDIT_TRAIL",
    title: "Audit Trail",
    path: "audit-trail",
    url: "/app/inventory/audit-trail",
    description: "audit trail",
    isVirtual: false,
    children: {},
  },
  AUDIT_TRAIL_EXPORT_CSV: {
    id: "AUDIT_TRAIL_EXPORT_CSV",
    title: "Audit Trail Export Csv",
    path: "audit-trail-export-csv",
    url: "/app/inventory/audit-trail-export-csv",
    description: "audit trail export csv",
    isVirtual: false,
    children: {},
  },
  AHS_INVENTORY_TRANSFER: {
    id: "AHS_INVENTORY_TRANSFER",
    title: "AHS Inventory Transfer",
    icon: "HiOutlineHome",
    path: "clinic-to-doctor-transfer",
    url: "/app/inventory/clinic-to-doctor-transfer",
    description: "clinic to doctor transfer orders",
    RBACDisplayName: "AHS_INVENTORY_TRANSFER",
    RBACDescription: "Access to clinic to doctor inventory transfer",
    isVirtual: false,
    children: {},
  },
  TRANSFER_ORDERS: {
    id: "TRANSFER_ORDERS",
    title: "Clinic to Clinic Transfer",
    icon: "HiOutlineHome",
    path: "inventory/order-transfer",
    url: "/app/inventory/order-transfer",
    description: "order transfer",
    RBACDisplayName: "TRANSFER_ORDERS",
    RBACDescription: "Access to clinic to clinic inventory transfer",
    isVirtual: false,
    children: {
      ...TRANSFER_SUB_NAV_ROUTES,
    },
  },
  AHS_CREATE_INVENTORY_TRANSFER: {
    id: "AHS_CREATE_INVENTORY_TRANSFER",
    title: "AHS Inventory Transfer",
    icon: "HiOutlineHome",
    path: "create-doctor-good-inventory",
    url: "/app/inventory/create-doctor-good-inventory",
    description: "clinic to doctor transfer orders",
    RBACDisplayName: "AHS_CREATE_INVENTORY_TRANSFER",
    RBACDescription: "Access to clinic to doctor inventory transfer",
    isVirtual: false,
    children: {},
  },

  // ── RBAC virtual features (inventory-scoped) ─────────────────────
  PO_CREATE_ACTION: {
    id: "PO_CREATE_ACTION",
    title: "purchase order create",
    path: "cta",
    RBACDisplayName: "PO_CREATE",
    RBACDescription: "Create/edit a Purchase Order (primary info, products, submit).",
    url: "/app/inventory/purchase-order/create-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_BULK_CREATE_FROM_SHEET_ACTION: {
    id: "PO_BULK_CREATE_FROM_SHEET_ACTION",
    title: "po bulk create from sheet",
    path: "cta",
    RBACDisplayName: "PO_BULK_CREATE_FROM_SHEET",
    RBACDescription: "Bulk-create multiple Purchase Orders from a sheet (PO list page).",
    url: "/app/inventory/purchase-order/bulk-create-from-sheet-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_UPLOAD_INVOICE_ACTION: {
    id: "PO_UPLOAD_INVOICE_ACTION",
    title: "po upload invoice",
    path: "cta",
    RBACDisplayName: "PO_UPLOAD_INVOICE",
    RBACDescription: "Upload an invoice against a Purchase Order (clinic side).",
    url: "/app/inventory/purchase-order/upload-invoice-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_FINANCE_UPLOAD_DOCUMENT_ACTION: {
    id: "PO_FINANCE_UPLOAD_DOCUMENT_ACTION",
    title: "po finance upload doc",
    path: "cta",
    RBACDisplayName: "PO_FINANCE_UPLOAD_DOCUMENT",
    RBACDescription: "Upload finance documents on a Purchase Order.",
    url: "/app/inventory/purchase-order/finance/upload-doc-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_GRN_EDIT_ACTION: {
    id: "PO_GRN_EDIT_ACTION",
    title: "po grn edit",
    path: "cta",
    RBACDisplayName: "PO_GRN_EDIT",
    RBACDescription: "Edit GRN fields (lot number, expiry, MRP) on a Purchase Order.",
    url: "/app/inventory/purchase-order/grn/edit-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_INVENTORY_DISPOSABLE_ACTION: {
    id: "BAD_INVENTORY_DISPOSABLE_ACTION",
    title: "bad inventory disposable",
    path: "cta",
    RBACDisplayName: "BAD_INVENTORY_DISPOSABLE",
    RBACDescription: "Mark a bad-inventory item as disposable.",
    url: "/app/inventory/bad/disposable-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_INVENTORY_INVALID_IMAGE_ACTION: {
    id: "BAD_INVENTORY_INVALID_IMAGE_ACTION",
    title: "bad inventory invalid image",
    path: "cta",
    RBACDisplayName: "BAD_INVENTORY_INVALID_IMAGE",
    RBACDescription: "Flag a bad-inventory image as invalid.",
    url: "/app/inventory/bad/invalid-image-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_INVENTORY_NON_DISPOSABLE_ACTION: {
    id: "BAD_INVENTORY_NON_DISPOSABLE_ACTION",
    title: "bad inventory non disposable",
    path: "cta",
    RBACDisplayName: "BAD_INVENTORY_NON_DISPOSABLE",
    RBACDescription: "Mark a bad-inventory item as non-disposable.",
    url: "/app/inventory/bad/non-disposable-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_INVENTORY_REJECT_REQUEST_ACTION: {
    id: "BAD_INVENTORY_REJECT_REQUEST_ACTION",
    title: "bad inventory reject request",
    path: "cta",
    RBACDisplayName: "BAD_INVENTORY_REJECT_REQUEST",
    RBACDescription: "Reject a bad-inventory request.",
    url: "/app/inventory/bad/reject-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_INVENTORY_BACK_TO_GOOD_ACTION: {
    id: "BAD_INVENTORY_BACK_TO_GOOD_ACTION",
    title: "bad inventory back to good",
    path: "cta",
    RBACDisplayName: "BAD_INVENTORY_BACK_TO_GOOD",
    RBACDescription: "Move an item back from bad to good inventory.",
    url: "/app/inventory/bad/back-to-good-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_INVENTORY_SHRINK_ACTION: {
    id: "BAD_INVENTORY_SHRINK_ACTION",
    title: "bad inventory shrink",
    path: "cta",
    RBACDisplayName: "BAD_INVENTORY_SHRINK",
    RBACDescription: "Mark bad inventory as shrink.",
    url: "/app/inventory/bad/shrink-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BAD_INVENTORY_REUPLOAD_IMAGE_ACTION: {
    id: "BAD_INVENTORY_REUPLOAD_IMAGE_ACTION",
    title: "bad inventory re-upload image",
    path: "cta",
    RBACDisplayName: "BAD_INVENTORY_REUPLOAD_IMAGE",
    RBACDescription: "Re-upload image for a bad-inventory request.",
    url: "/app/inventory/bad/reupload-image-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  GOOD_INVENTORY_ROW_ACTION: {
    id: "GOOD_INVENTORY_ROW_ACTION",
    title: "good inventory row action",
    path: "cta",
    RBACDisplayName: "GOOD_INVENTORY_ROW_ACTION",
    RBACDescription: "Row-level actions on Good Inventory table (kebab menu).",
    url: "/app/inventory/good/row-action-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  GOOD_TO_BAD_ALL_REASONS_ACTION: {
    id: "GOOD_TO_BAD_ALL_REASONS_ACTION",
    title: "good to bad all reasons",
    path: "cta",
    RBACDisplayName: "GOOD_TO_BAD_ALL_REASONS",
    RBACDescription: "See the full (unfiltered) Good→Bad reason list in the modal.",
    url: "/app/inventory/good-to-bad/all-reasons-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  TRANSFER_ORDER_OMS_DASHBOARD_LINK: {
    id: "TRANSFER_ORDER_OMS_DASHBOARD_LINK",
    title: "transfer oms link",
    path: "cta",
    RBACDisplayName: "TRANSFER_ORDER_OMS_DASHBOARD_LINK",
    RBACDescription: "Show 'Link to OMS Dashboard' button on Transfer Order details.",
    url: "/app/inventory/transfer/oms-link-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  INVENTORY_SNAPSHOT_ROW_ACTION: {
    id: "INVENTORY_SNAPSHOT_ROW_ACTION",
    title: "inventory snapshot row action",
    path: "cta",
    RBACDisplayName: "INVENTORY_SNAPSHOT_ROW_ACTION",
    RBACDescription: "Row-level actions on the Inventory Snapshot Good tab.",
    url: "/app/inventory/snapshot/row-action-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_FINANCE_ADMIN_ACTION: {
    id: "PO_FINANCE_ADMIN_ACTION",
    title: "po finance admin action",
    path: "cta",
    RBACDisplayName: "PO_FINANCE_ADMIN_ACTION",
    RBACDescription: "Finance admin — upload-documents dropdown behavior on Finance PO listing.",
    url: "/app/inventory/purchase-order/finance/admin-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_GRN_CLINIC_MARK_COMPLETE_ACTION: {
    id: "PO_GRN_CLINIC_MARK_COMPLETE_ACTION",
    title: "po grn mark complete",
    path: "cta",
    RBACDisplayName: "PO_GRN_CLINIC_MARK_COMPLETE_ACTION",
    RBACDescription: "Show the 'Mark GRN Complete' clinic-side submit button on GRN.",
    url: "/app/inventory/purchase-order/grn/mark-complete-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_ISSUE_IN_GRN_CLINIC_ACTION: {
    id: "PO_ISSUE_IN_GRN_CLINIC_ACTION",
    title: "po issue in grn clinic action",
    path: "cta",
    RBACDisplayName: "PO_ISSUE_IN_GRN_CLINIC_ACTION",
    RBACDescription: "Show clinic-side action button when PO is in issue_in_grn status.",
    url: "/app/inventory/purchase-order/issue-in-grn-clinic-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PO_ISSUE_IN_INVOICE_UPLOAD_CLINIC_ALERT: {
    id: "PO_ISSUE_IN_INVOICE_UPLOAD_CLINIC_ALERT",
    title: "po issue in invoice upload clinic alert",
    path: "cta",
    RBACDisplayName: "PO_ISSUE_IN_INVOICE_UPLOAD_CLINIC_ALERT",
    RBACDescription: "Show the clinic-side 'Re-upload Invoice' alert when PO is in issue_in_invoice_upload status.",
    url: "/app/inventory/purchase-order/issue-in-invoice-clinic-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  TRANSFER_ORDER_CLINIC_GRN_ACTION: {
    id: "TRANSFER_ORDER_CLINIC_GRN_ACTION",
    title: "transfer order clinic grn action",
    path: "cta",
    RBACDisplayName: "TRANSFER_ORDER_CLINIC_GRN_ACTION",
    RBACDescription: "Show the clinic-side GRN button on Transfer Order details.",
    url: "/app/inventory/transfer/grn-clinic-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  GOOD_TO_BAD_CLINIC_REASONS_FILTER: {
    id: "GOOD_TO_BAD_CLINIC_REASONS_FILTER",
    title: "good to bad clinic reasons filter",
    path: "cta",
    RBACDisplayName: "GOOD_TO_BAD_CLINIC_REASONS_FILTER",
    RBACDescription: "Good→Bad modal — apply the clinic-side filtered reasons subset (only REMOVE_TITLES).",
    url: "/app/inventory/good-to-bad/clinic-filter-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },

  STAFF_ONBOARD_UNRESTRICTED_ROLE_LIST: {
    id: "STAFF_ONBOARD_UNRESTRICTED_ROLE_LIST",
    title: "staff onboard unrestricted role list",
    path: "cta",
    RBACDisplayName: "STAFF_ONBOARD_UNRESTRICTED_ROLE_LIST",
    RBACDescription: "Staff Onboard — see the full list of staff roles (not just the allowed subset).",
    url: "/app/staff-onboard/unrestricted-roles-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
};
